import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ReCaptchaKey} from '../../../shared/const/reCaptchaKey';
import {TranslateService} from '@ngx-translate/core';
import {ReferenceService} from '../../../shared/services/reference.service';
import {SubjectService} from '../../../shared/services/subject.service';
import {AnonymousService} from '../../../shared/services/anonymous.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ReCaptchaV3Service} from 'ngx-captcha';

@Component({
    selector: 'app-request-move',
    templateUrl: './request-move.component.html'
})
export class RequestMoveComponent implements OnInit {

    requestForm: FormGroup;
    objectList: any;
    siteKey = ReCaptchaKey.siteKey;
    action: string;
    pageTitle = '';

    constructor(public translate: TranslateService,
                private referenceService: ReferenceService,
                private subjectService: SubjectService,
                private anonService: AnonymousService,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private reCaptchaV3Service: ReCaptchaV3Service) {
    }

    ngOnInit() {
        this.action = this.activatedRoute.snapshot.data.action;

        if (this.action === 'departure') {
            this.pageTitle = 'request_departure';
        } else if (this.action === 'arrival') {
            this.pageTitle = 'request_arrival';
        }

        this.requestForm = new FormGroup({
            inn: new FormControl(null, Validators.required),
            objectId: new FormControl(null, Validators.required)
        });
    }

    async onInputSubjectINN() {
        if (this.requestForm.value.inn.length === 14) {
            const objects = await this.subjectService.getObjectsBySubjectInn(this.requestForm.value.inn);
            if (objects.length) {
                this.objectList = objects.map(object => {
                    return {
                        label: `${object.sysObjectId} - ${object.topoGeoDetails} / ${object.address}`,
                        value: object.id
                    };
                });
            }
        } else {
            this.requestForm.controls.objectId.reset(null);
            this.objectList = null;
        }
    }

    onSubmit() {
        this.reCaptchaV3Service.execute(this.siteKey, `AITSRequest${this.action}`, async (token) => {
            const requestData = {
                ...this.requestForm.value,
                captchaToken: token
            };

            if (this.action === 'departure') {
                await this.anonService.requestDeparture(requestData);
            } else if (this.action === 'arrival') {
                await this.anonService.requestArrival(requestData);
            }

            this.router.navigate(['/home']);
        }, {
            useGlobalDomain: false
        });
    }
}
